module.exports = __webpack_public_path__ + "img/error.5524ec05.png";